export default __webpack_public_path__ + "static/media/bg-paper-white-large.247d052a.png";